<div>
    <mat-form-field appearance="outline" class="searchMatFormField" style="border-color: red;">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label style="font-size: 15px;" >{{placeHolder}}
        </mat-label>
        <input matInput (keydown.enter)="onSearch()" [(ngModel)]="search" />
    </mat-form-field>
    <button *ngIf="!hideButton" mat-raised-button class="search-button" (click)="onSearch()">{{'Search' | translate}}</button>
</div>
